import {AnyEvent, JOBS_DELETED_EVENT, JobsDeletedEvent} from '../type';

export default function jobsDeleted(payload: JobsDeletedEvent['payload']): AnyEvent {
  return {
    type: JOBS_DELETED_EVENT,
    payload,
  }
}